if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"core_hr","remotes":[],"shareStrategy":"loaded-first"},
		chunkMatcher: function(chunkId) {return !/^(4(288|506|705)|8(069|274|466)|9(241|427|892)|2090|2167|3357|3784|5704|6136|7399)$/.test(chunkId)},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}